import { mobilePageTitleAtom } from 'config/store'
import { useAtom } from 'jotai'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { makeData } from 'utils/makeData'
import friendStatus from 'assets/images/invite-friend-status.svg'
import { Button, Col, Container, Row } from 'react-bootstrap'
import CreateRoomModal from 'components/Modal/CreateRoomModal'
import { useQuery } from 'react-query'
import { getFriendQuery } from 'dataLayer/game'
import avaDefault from 'assets/images/ava-default.jpeg'
import noDataIcon from 'assets/images/profilepage-gifthist-nodata.svg'

function FriendMobile({ title }) {
	const { t } = useTranslation()

	const { data: friends, isLoading } = useQuery(getFriendQuery())

	const [, setMobilePageTitle] = useAtom(mobilePageTitleAtom)
	useEffect(() => {
		setMobilePageTitle(title)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const [modalInvite, setModalInvite] = useState(false)
	function openInviteModal() {
		setModalInvite(true)
	}
	function closeInviteModal() {
		setModalInvite(false)
	}

	return (
		<>
			<Container fluid className="profilepage-content mobile invitation mt-3">
				<Row
					className="profilepage-content__body invitation header mt-3 py-0 px-2 px-sm-3"
					style={{ height: 40, width: '100%' }}
				>
					<Col xs={6} style={{ fontSize: 14 }}>
						{t('profile.invitation.name')}
					</Col>
					{/* <Col xs={6} className="ps-0" style={{ fontSize: 14 }}>
						{t('profile.invitation.gold')}
					</Col> */}
				</Row>
				<Row className="profilepage-content__body invitation body mobile mt-3 py-2 px-2 px-sm-3">
					{friends && friends.length > 0 ? (
						friends?.map(item => {
							return (
								<div
									key={item?.id}
									className="d-flex align-items-center py-2 px-0"
								>
									<Col xs={10} className="friend-info">
										<div className="friend-info__ava me-2">
											<img
												src={item?.image || avaDefault}
												alt="Inviter's avatar"
											/>
											{item.status === 1 ? (
												<img src={friendStatus} alt="Friend's status" />
											) : null}
										</div>
										<p style={{ fontSize: 12 }}>{item?.full_name}</p>
									</Col>
									{/* <Col xs={4} className="inviter-bet">
									<p style={{ fontSize: 12 }}>
										{new Intl.NumberFormat('lo').format(item?.gold)}
									</p>
								</Col> */}
									<Col xs={2} className="inviter-interact">
										<Button
											onClick={openInviteModal}
											disabled={item.status === 0}
										>
											{t('friendpage.invite')}
										</Button>
									</Col>
								</div>
							)
						})
					) : (
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								height: 300,
							}}
						>
							<img
								style={{ width: '70%' }}
								src={noDataIcon}
								alt="No reward is found"
							/>
						</div>
					)}
				</Row>
			</Container>
			<CreateRoomModal
				show={modalInvite}
				onHide={closeInviteModal}
				title={t('friendpage.invite_play')}
				friendPage={true}
				friendMobile={true}
			/>
		</>
	)
}

export default FriendMobile
